import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { CompanyListComponent } from './company-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [CompanyListComponent],
  declarations: [CompanyListComponent],
})
export class CompanyListModule { }
